import * as types from './mutation-types'
import { saveBaseInfo, saveShareBaseInfo, saveProductionInfo } from 'utils/cache'
import {
  getWeatherDataType
} from '@/api/common'

import {
  login
} from '@/api/user'
import {
  setToken,
  setUserInfo
} from '@/utils/auth'

// 登录
export const getLogin = function ({
  commit
}, userInfo) {
  const phone = userInfo.phone.trim()
  return new Promise((resolve, reject) => {
    login(phone, userInfo.password).then(response => {
      if (response.code !== 0) {
        console.log('用户或密码错误')
        resolve(response)
        return
      }
      const data = response.data
      setUserInfo(data)
      setToken(data.token)
      commit('SET_USERINFO', data)
      commit('SET_TOKEN', data.token)
      resolve(response)
    }).catch(error => {
      reject(error)
    })
  })
}

export const setBaseInfo = function ({commit}, { baseInfo }) {
  commit(types.SET_BASEINFO, baseInfo)
  saveBaseInfo(baseInfo)
}

export const setProductionInfo = function ({commit}, { productionInfo }) {
  commit(types.SET_PRODUCTIONINFO, productionInfo)
  saveProductionInfo(productionInfo)
}

export const setShareBaseInfo = function ({commit}, { baseInfo }) {
  commit(types.SET_SHARE_BASEINFO, baseInfo)
  saveShareBaseInfo(baseInfo)
}

export const getWeatherDataTypeInfo = function ({ commit, state }) {
  return new Promise((resolve, reject) => {
    getWeatherDataType({})
    .then(resp => {
      const resData = resp
      const data = resData.data
      const tempChNameByNum = {}
      const tempEnNameByNum = {}
      const tempNumByEnName = {}
      const tempNumByChName = {}
      const tempChNameByEnName = {}
      const tempUnit = {}

      const tempDeviceId = {
        english_name: 'device_id',
        name: '设备id',
        type: -2,
        unit: ''
      }
      const tempDeviceName = {
        english_name: 'device_name',
        name: '设备名',
        type: -3,
        unit: ''
      }

      if (data && data.length) {
        data.push(tempDeviceId)
        data.push(tempDeviceName)

        data.forEach(item => {
          // -1，忽略
          if (item.type === '-1') return
          tempChNameByNum[item.type] = item.name
          tempEnNameByNum[item.type] = item.english_name
          tempNumByEnName[item.english_name] = item.type
          tempNumByChName[item.name] = item.type
          tempChNameByEnName[item.english_name] = item.name
          tempUnit[item.type] = item.unit
        })
      }
      commit('SET_WEATHER_DATA_TYPE', {
        chNameByNum: tempChNameByNum,
        enNameByNum: tempEnNameByNum,
        numByEnName: tempNumByEnName,
        numByChName: tempNumByChName,
        chNameByEnName: tempChNameByEnName,
        unit: tempUnit
      })
      resolve(resp)
    })
    .catch(error => {
      reject(error)
      console.log(error)
    })
  })
}



// WEBPACK FOOTER //
// ./src/store/actions.js